import axios from "axios";
import { PROXY_API } from "../config";
import i18n from "../locales/i18n";
import { getAppCheckToken } from "../services/appCheck";
import { AUTH } from "../auth/FirebaseContext";

// ============================================================
// JAVNI AXIOS - za pretragu stanica, polazaka, itd.
// Ide preko bussoft CF proxy-ja koji dodaje auth server-side
// Korisnik NE mora biti ulogovan
// ============================================================

const proxyBaseURL = PROXY_API;

export const customSpringAxios = axios.create({
    baseURL: proxyBaseURL,
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: false,
});

customSpringAxios.interceptors.request.use(
    async (config) => {
        const appCheckToken = await getAppCheckToken();
        if (appCheckToken) {
            config.headers["X-Firebase-AppCheck"] = appCheckToken;
        }
        const user = AUTH.currentUser;
        if (user) {
            config.headers.Authorization = `Bearer ${await user.getIdToken()}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);

customSpringAxios.interceptors.response.use(
    (response) => response,
    async (error) => {
        if (axios.isCancel(error) || error?.code === "ERR_CANCELED") {
            return Promise.reject(error);
        }

        const original = error?.config;
        if (error?.response?.status === 401 && AUTH.currentUser && original && !original._bearerRetried) {
            original._bearerRetried = true;
            try {
                const fresh = await AUTH.currentUser.getIdToken(true);
                original.headers.Authorization = `Bearer ${fresh}`;
                return customSpringAxios(original);
            } catch (refreshErr) {
                // pad osvežavanja — nastavi na standardnu obradu greške
            }
        }
        return Promise.reject((error.response && error.response.data) || i18n.t("common.somethingWrong"));
    },
);

